import React from 'react';
import Bricks from 'bricks.js';
import InfiniteScroll from 'react-infinite-scroller';

const ITEMS_PER_PAGE = 40;

export default class BricksLayout extends React.Component {
  static defaultProps = {
    className: '',
    packed: 'data-packed',
    position: true,
    sizes: [
      //{ columns: 2, gutter: 0 },
      //{ mq: '768px', columns: 3, gutter: 0 },
      { columns: 4, gutter: 0 },
    ],
    style: {},
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      page: 1,
    };
  }

  componentDidMount() {
    const { packed, sizes, photos = [], position, columns } = this.props;

    this.instance = Bricks({
      container: this.masonryContainer,
      packed: packed,
      sizes: columns ? [{ columns, gutter: 0 }] : sizes,
      position: position,
    });

    if (photos.length > 0) {
      this.instance.pack();
    }
  }

  componentWillUnmount() {
    this.masonryContainer.removeAttribute('style');
    this.masonryContainer = null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { packed, sizes, photos = [], position, columns } = this.props;
    const { page } = this.state;

    this.instance = Bricks({
      container: this.masonryContainer,
      packed: packed,
      sizes: columns ? [{ columns, gutter: 0 }] : sizes,
      position: position,
    });
    this.instance.pack();

    if ((prevProps.photos || []).length === 0 && photos.length > 0) {
      this.instance.pack();
    } else if (page !== prevState.page || (prevProps.photos || []).length !== photos.length) {
      this.instance.update();
    }
  }

  loadMore = () => {
    this.setState(state => ({
      page: state.page + 1,
    }));
  };

  render() {
    const { className, lazyLoad, style, photos = [] } = this.props;
    const { page } = this.state;

    if (lazyLoad) {
      const visiblePhotos = photos.slice(0, ITEMS_PER_PAGE * page);

      return (
        <InfiniteScroll loadMore={this.loadMore} hasMore={photos.length > visiblePhotos.length} useWindow={false}>
          <div ref={c => (this.masonryContainer = c)} className={className} style={style}>
            {visiblePhotos}
          </div>
        </InfiniteScroll>
      );
    } else {
      return (
        <div ref={c => (this.masonryContainer = c)} className={className} style={style}>
          {photos}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/bricks/index.js